import { dev } from "$app/environment";

export const dprint = (obj: any) => {
    if (dev) {
        return console.debug(obj);
    }
}